import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalComponent } from './portal/portal.component';
import { GridComponent } from './grid/grid.component';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    PortalComponent,
    GridComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class DashboardModule { }
